import { Component } from '@angular/core';

@Component({
    selector: 'motors-maintenance',
    templateUrl: './motors-maintenance.component.html',
    styleUrls: ['./motors-maintenance.component.scss'],
    standalone: false
})
export class MotorsMaintenanceComponent {}
